import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import UserContext from "../../../context/UserContext";
import PageContainer from "../../common/PageContainer";
import PageContent from "../../common/PageContent";
import SmartViewsTraceContent from "../smart-views-trace/SmartViewsTraceContent";
import SystemMaintenanceContent from "./SystemMaintenanceContent";

const SystemMaintenancePage = () => {
  const { permissions } = useDefinedContext(UserContext);
  const canMaintain = permissions.includes("PerformSystemMaintenance");
  const canTrace = permissions.includes("UseSmartViewsTrace");

  const menuItems = [
    ...(canMaintain ? [{ name: "system-maintenance", label: "System Maintenance" }] : []),
    ...(canTrace ? [{ name: "smart-views-trace", label: "SmartViews Trace" }] : []),
  ];

  return (
    <PageContainer menuItems={menuItems}>
      {canMaintain && (
        <PageContent name="system-maintenance">
          <SystemMaintenanceContent />
        </PageContent>
      )}
      {canTrace && (
        <PageContent name="smart-views-trace">
          <SmartViewsTraceContent />
        </PageContent>
      )}
    </PageContainer>
  );
};

export default SystemMaintenancePage;
